import { Instagram, Facebook, Music2, Mail, Phone, MapPin } from 'lucide-react';
import logo from '@/assets/logo.png';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const socialLinks = [
    { icon: Instagram, href: 'https://www.instagram.com/perfumeriatyche/', label: 'Instagram' },
    { icon: Facebook, href: 'https://facebook.com/violeta.shopp.37', label: 'Facebook' },
    { icon: Music2, href: 'https://www.tiktok.com/@perfumeriatyche', label: 'TikTok' },
  ];

  return (
    <footer className="bg-background border-t border-border">
      <div className="container mx-auto px-4 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-6">
              <img
                src={logo}
                alt="Tyche"
                className="h-14 w-14 object-contain"
              />
              <span className="font-display text-2xl font-semibold text-primary">
                Tyche
              </span>
            </div>
            <p className="font-body text-muted-foreground max-w-sm leading-relaxed mb-6">
              Perfumería y joyería de autor. Donde el lujo, la elegancia y la 
              exclusividad se encuentran para crear momentos inolvidables.
            </p>
            {/* Social Links */}
            <div className="flex gap-4">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 rounded-full border border-border flex items-center justify-center text-muted-foreground hover:border-primary hover:text-primary transition-all duration-300"
                  aria-label={social.label}
                >
                  <social.icon className="w-5 h-5" />
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-display text-lg font-semibold text-foreground mb-6">
              Navegación
            </h4>
            <ul className="space-y-3">
              {['Inicio', 'Colecciones', 'Sobre Tyche', 'Testimonios', 'Contacto'].map((link) => (
                <li key={link}>
                  <button
                    onClick={() => {
                      const id = link.toLowerCase()
                        .replace('colecciones', 'productos')
                        .replace('sobre tyche', 'sobre')
                        .replace('inicio', 'hero');
                      document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
                    }}
                    className="font-body text-sm text-muted-foreground hover:text-primary transition-colors duration-300"
                  >
                    {link}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-display text-lg font-semibold text-foreground mb-6">
              Contacto
            </h4>
            <ul className="space-y-4">
              <li>
                <a
                  href="mailto:tycheperfumeria@gmail.com"
                  className="flex items-center gap-3 font-body text-sm text-muted-foreground hover:text-primary transition-colors duration-300"
                >
                  <Mail className="w-4 h-4 text-primary" />
                  tycheperfumeria@gmail.com
                </a>
              </li>
              <li>
                <a
                  href="tel:+573245044606"
                  className="flex items-center gap-3 font-body text-sm text-muted-foreground hover:text-primary transition-colors duration-300"
                >
                  <Phone className="w-4 h-4 text-primary" />
                  +57 324 504 46 06
                </a>
              </li>
              <li>
                <a
                  href="https://maps.app.goo.gl/rzob91zuvMGXGsyo6"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-start gap-3 font-body text-sm text-muted-foreground hover:text-primary transition-colors duration-300"
                >
                  <MapPin className="w-4 h-4 text-primary flex-shrink-0 mt-0.5" />
                  <span>Cl. 150 #48 - 71<br />Victoria Norte, Bogotá, Cundinamarca</span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-border flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="font-body text-sm text-muted-foreground">
            © {currentYear} Tyche. Todos los derechos reservados.
          </p>
          <div className="line-gold w-16 hidden md:block" />
          <p className="font-body text-xs text-muted-foreground/60">
            Perfumería y Joyería de Autor
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
